import classNames from 'classnames';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { twMerge } from 'tailwind-merge';
import { Container } from '../common/base';
import { ArrowSmRightIcon } from '@heroicons/react/solid';
import RemoteText from '../common/remoteText';
import React from "react"

export function IndustryRecognised({ className }) {
    const { allContentfulSiteImages } = useStaticQuery(graphql`
        {
            allContentfulSiteImages(filter: {name: {in: [
                "Award Proptech", 
                "Member Property Council", 
                "Government Guarantee Logo HiRes", 
                "Proptech 2025", 
                "Proptech finalist - Start up", 
                "Proptech finalist - Commercial", 
                "Proptech finalist - proptech to watch"
            ]}}) {
                nodes {
                    id
                    name
                    imageFile {
                        localFile {
                            childImageSharp {
                                gatsbyImageData(layout: CONSTRAINED, height: 200)
                            }
                        }
                    }
                }
            }
        }
    `);

    // Create a map of images by name for easy access
    const images = allContentfulSiteImages.nodes.reduce((acc, node) => {
        acc[node.name] = node;
        return acc;
    }, {});

    // Define image arrays for each row
    const firstRowImages = [
        { image: images["Government Guarantee Logo HiRes"], alt: 'Government Guarantee', extraPadding: false },
        { image: images["Member Property Council"], alt: 'Property Council Membership', extraPadding: false },
        { image: images["Award Proptech"], alt: 'Proptech Award', extraPadding: false },
        { image: images["Proptech 2025"], alt: 'Proptech Finalist 2025', extraPadding: false },
    ];

    const secondRowImages = [
        { image: images["Proptech finalist - Commercial"], alt: 'Proptech Finalist 2025 Commercial', extraPadding: true },
        { image: images["Proptech finalist - Start up"], alt: 'Proptech Finalist 2025 Startup', extraPadding: true },
        { image: images["Proptech finalist - proptech to watch"], alt: 'Proptech Finalist 2025 Watch', extraPadding: true },
    ];

    return (
        <section>
            <Container className={twMerge(classNames('my-20 grid gap-10 lg:grid-cols-2 items-center', className))}>
                <div className='space-y-8 flex flex-col justify-center h-full lg:pr-10 md:pr-0'>
                    <h2 className='text-4xl tracking-tighter md:text-5xl'>
                        <RemoteText name='BeneficiaryIndustryRecognisedHeading' />
                        <div className='relative -top-2 inline-block'>
                            <ArrowSmRightIcon className='h-6 xl:h-8' />
                        </div>
                    </h2>
                    <div className='text-xl'>
                        <RemoteText name='BeneficiaryIndustryRecognisedBlurb' />
                    </div>
                </div>

                <div className='flex flex-col items-center justify-center space-y-2 h-full'>
                    {/* First row of images */}
                    <div className='flex justify-center items-center space-x-2'>
                        {firstRowImages.map((item, index) => (
                            item.image && (
                                <div key={item.image.id || index} className={item.extraPadding ? 'px-2' : ''}>
                                    <GatsbyImage
                                        loading='lazy'
                                        image={item.image?.imageFile?.localFile?.childImageSharp?.gatsbyImageData}
                                        alt={item.alt}
                                        className={twMerge('[width:60px] [height:60px] xs:[width:100px] xs:[height:100px] xl:[width:160px] xl:[height:160px] mx-auto [&>picture>img]:!object-contain')}
                                    />
                                </div>
                            )
                        ))}
                    </div>
                    {/* Second row of images */}
                    <div className='flex justify-center items-center space-x-2'>
                        {secondRowImages.map((item, index) => (
                            item.image && (
                                <div key={item.image.id || index} className={item.extraPadding ? 'px-2' : ''}>
                                    <GatsbyImage
                                        loading='lazy'
                                        image={item.image?.imageFile?.localFile?.childImageSharp?.gatsbyImageData}
                                        alt={item.alt}
                                        className={twMerge('[width:60px] [height:60px] xs:[width:100px] xs:[height:100px] xl:[width:160px] xl:[height:160px] mx-auto [&>picture>img]:!object-contain')}
                                    />
                                </div>
                            )
                        ))}
                    </div>
                </div>
            </Container>
        </section>
    );
}
